<template>
  <div
    class="lock-button-component-container"
    @click.prevent.stop="click"
  >
    <icon
      name="lock"
      variant="516173"
    />
    <span>UNLOCK</span>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: { Icon },
  props: {
    resource: {
      type: Object,
    },
    source: {
      type: Object,
    },
    type: {
      type: String,
      default: function() {
        return this.$store.getters['app/pricingType'];
      },
    },
  },
  methods: {
    click() {
      this.$analytics.events.clickedUpsell(this.$store, 'Locked Content', this.type);
      this.$store.dispatch('ui/toggleUpsellModal', { show: true, source: this.source, resource: this.resource });
    },
  },
};
</script>
<style lang='scss' scoped>
  .lock-button-component-container {
    align-items: center;
    background-image: linear-gradient(to top, #f2f4f7, #ffffff);
    border: 1px solid #E4E7EC;
    border-radius: 4px;
    box-sizing: border-box;
    display: flex;
    margin-right: rem-calc(16);
    padding: rem-calc(4);
    width: rem-calc(65);

    span {
      font-size: rem-calc(10);
      font-weight: $semi-bold;
      margin-left: rem-calc(5);
    }

    img {
      width: rem-calc(9);
    }
  }
</style>
